module.exports = __webpack_public_path__ + "static/media/megapolis.fe52fbdb.svg";